<template>
  <div class="seo">
    <Header :title="title"></Header>
    <section class="hero is-small">
      <div class="hero-body">
        <div class="container level">
        <div class="field">
          <div class="control">
            <p class="title is-size-5 level-item"> {{ this.today | moment("dddd, MMMM Do YYYY") }} </p>
          </div>
        </div>

<!-- <div class="dropdown is-active is-right is-hoverable"> -->
<div class="dropdown is-right is-hoverable">
  <div class="dropdown-trigger">
    <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
      <span>Options</span>
      <span class="icon is-small">
        <i class="fas fa-angle-down" aria-hidden="true"></i>
      </span>
    </button>
  </div>
  <div class="dropdown-menu" id="dropdown-menu" role="menu">
    <div class="dropdown-content">
          <a class="dropdown-item" @click="closeRate">Close rate CHECK</a>
          <a class="dropdown-item" @click="acquiredPlus(0.5)">acquiredPlus</a>
          <a class="dropdown-item" @click="conversionsPlus(0.5)">NUM OF CONVERSIONS</a>
          <a class="dropdown-item" @click="costPerConversionPlus">costperconversionplus</a>
          <a class="dropdown-item" @click="closeRateTen">Close rate: 10% - Low</a>
          <a class="dropdown-item" @click="closeRateTwenty">Close rate: 20% - Typical</a>
          <a class="dropdown-item" @click="closeRateThirty">Close rate: 30% - Best in class</a>
          <hr class="dropdown-divider">
          <a class="dropdown-item" @click="closeRateEcommerce">Industry: E-commerce</a>
          <!-- <a class="dropdown-item" @click="closeRateEnterprise">Industry: Enterprise</a> -->
          <hr class="dropdown-divider">
          <a class="dropdown-item" @click="agencyFeesIncluded = !agencyFeesIncluded"> <span v-show="agencyFeesIncluded">Exclude agency cost</span> <span v-show="!agencyFeesIncluded">Include agency cost</span></a>
          <hr class="dropdown-divider">
          <a class="dropdown-item" @click="resetValues">Reset values</a>
          <a class="dropdown-item" @click="dummyValues">Dummy values</a>
    </div>
  </div>
</div>

        </div>
      </div>
    </section>

<section class="container">
<div class="tile is-ancestor has-text-centered">
                        <div class="tile is-parent">
                            <article class="tile is-child box">

<h2 class="title is-size-4">
            Campaigns
          </h2>
            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Amount paid to Google to run ads.">Ad spend per month
               <span class="icon" @click="showModal">
                  <i class="fas fa-question-circle"></i>
              </span>
                </label>
            </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <money class="input" :adSpend="adSpend" v-bind="moneyNoDecimal" v-model="adSpend" ></money>
                  </div>
                  <p v-if="adSpend !== 0" class="annual-spend">Annual spend of {{ formatNumber(adSpend * 12) }}</p>
                </div>
              </div>
            </div>

            <span v-show="agencyFeesIncluded">
              <div class="field columns">
                <div class="field-label column">
                  <label class="label tooltip-top" data-tooltip="Novicell optimisation and management fee.">Agency cost per month
                  </label>
                </div>
                <div class="field-body column">
                  <div class="field">
                    <div class="control">
                      <money class="input" :agencyCost="agencyCost" v-bind="moneyNoDecimal" v-model="agencyCost" ></money>
                    </div>
                    <p v-if="agencyCost !== 0" class="annual-spend">Annual agency cost of {{ formatNumber(agencyCost * 12) }}</p>
                  </div>
                </div>
              </div>
            </span>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Price you pay Google for each ad click and visit to you site.">Average cost-per-click</label>
              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <money class="input" v-bind="money" v-model="costPerClick"></money>
                  </div>
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Visits to your website from ads.">Total website visits</label>
              </div>
              <div class="column">
                    <p v-if="costPerClick !== 0"> {{ formatNumberOnly(websiteVisits) }} new visits</p>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Percentage of users who take a desired action. ">Website conversion rate
                  <span class="icon" @click="showModalConversion">
                    <i class="fas fa-question-circle"></i>
                  </span>
                </label>

              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <money class="input" v-bind="percent" v-model="conversionRate"></money>
                  </div>
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Total number of conversions.">Conversions or leads</label>
              </div>
              <div class="column">
                <p v-if="conversionRate !== 0"> {{ formatNumberOnly(conversions) }} new leads</p>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="How much you pay for each lead.">Cost per raw conversion</label>
              </div>
              <div class="column">
                <p v-if="conversionRate !== 0"> {{ formatNumber(costPerConversion) }} </p>
              </div>
            </div>


                            </article>
                        </div>
                        <div class="tile is-parent">
                            <article class="tile is-child box">


<h3 class="title is-size-4">
            Sales funnel
          </h3>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Percentage of leads that receive a response.">Quality leads</label>
              </div>
              <div class="column">
                  <div class="control">
                    <money class="input" v-bind="percentNoDecimal" v-model="percentageResponse"></money>
                    <p>
                      <span v-if="percentageResponse !== 0 && conversionRate !== 0"> {{ formatNumberOnly(qualityLeads) }} leads </span>
                    </p>
                  </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Percentage that you then send a proposal or quote.">Proposal given</label>
              </div>
              <div class="column">
                  <div class="control">
                    <money class="input" v-bind="percentNoDecimal" v-model="percentageProposals"></money>
                    <span v-if="percentageProposals !== 0 && conversionRate !== 0">{{ formatNumberOnly(proposals) }} proposals</span>
                  </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Percentage that become a paying client.">New customer acquired</label>
              </div>
              <div class="column">
                  <div class="control">
                    <money class="input" v-bind="percentNoDecimal" v-model="percentageAcquired"></money>
                    <span v-if="percentageAcquired !== 0 && conversionRate !== 0">{{ formatNumberOnly(acquired) }} new customers</span>
                  </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Mean average deal size or basket size.">Average deal size</label>
              </div>
              <div class="column">
                  <div class="control">
                    <money class="input" v-bind="moneyNoDecimal" v-model="dealSize"></money>
                  </div>
              </div>
            </div>


            <div class="field columns">
              <div class="field-label column">
                <label class="label tooltip-top" data-tooltip="Gross sales margin.">Margin</label>
              </div>
              <div class="column">
                  <div class="control">
                    <money class="input" v-bind="percentNoDecimal" v-model="margin"></money>
                  </div>
              </div>
            </div>


                            </article>
                        </div>

                    </div>
</section>

<section class="container">
  <body>
<div class="tile is-ancestor has-text-centered">
                        <div class="tile is-parent">
                            <article class="tile is-child box">
                                <p class="title" v-if="dealSize !== 0 && margin !== 0"> {{ formatNumber(netRevenue) }} </p>
                                <p class="title" v-else>£0</p>
                                <p class="subtitle">Rev. per lead</p>
                            </article>
                        </div>
                        <div class="tile is-parent">
                            <article class="tile is-child box">
                                <p class="title" v-if="adSpend !== 0 && acquired !== 0"> {{ formatNumber(costPerSale) }} </p>
                                <p class="title" v-else>£0</p>
                                <p class="subtitle">Cost per sale</p>
                            </article>
                        </div>
                        <div class="tile is-parent">
                            <article class="tile is-child box" :class="{'highlightGreen': (profit > 0),  'highlightRed': (profit < 0)}">
                                <p class="title" v-if="costPerSale !== 0 && netRevenue !== 0"> {{ formatNumberOnly(returnOnPaidInvestment) }}% </p>
                                <p class="title" v-else>0%</p>
                                <p class="subtitle">ROI</p>
                            </article>
                        </div>
                        <div class="tile is-parent">

                            <article class="tile is-child box" :class="{'highlightGreen': (profit > 0),  'highlightRed': (profit < 0)}">
                                <p class="title" v-if="costPerSale !== 0 && netRevenue !== 0"> £{{ formatNumberOnly(profit) }} </p>
                                <p class="title" v-else>£0</p>
                                <p class="subtitle">Profit monthly</p>
                            </article>
                        </div>
                        <div class="tile is-parent">
                            <article class="tile is-child box" :class="{'highlightGreen': (profit > 0),  'highlightRed': (profit < 0)}">
                                <p class="title" v-if="costPerSale !== 0 && netRevenue !== 0"> £{{ formatNumberOnly(profit * 12) }} </p>
                                <p class="title" v-else>£0</p>
                                <p class="subtitle">Profit annual
                                </p>
                            </article>
                        </div>
                    </div>
  </body>
</section>

<ModalAdSpend></ModalAdSpend>
<ModalConversionRate></ModalConversionRate>

<section v-show="profit" class="box container" id="scenario-analysis">

<body>
        <h1 class="title is-size-4">Scenario analysis</h1>
        <h2 class="title is-size-5">Scenario 1: Conversion Rate of {{ conversionRate }}%</h2>

<div class="level is-centered">

<table v-show="acquired" class="table is-hoverable is-narrow is-centered">
  <thead class="is-size-5">
    <tr>
      <th><abbr class="is-size-6" title="Scenario">Cumulative</abbr></th>
      <th>{{ this.today | moment("MMM") }}</th>
      <th>{{ this.today | moment("add", "1 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "2 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "3 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "4 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "5 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "6 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "7 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "8 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "9 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "10 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "11 month", "MMM") }}</th>
    </tr>
  </thead>
  <!-- <tfoot>
    <tr>
      <th><abbr title="Scenario">Scenario</abbr></th>
      <th>Month 1</th>
      <th>Month 2</th>
      <th>Month 3</th>
      <th>Month 4</th>
      <th>Month 5</th>
      <th>Month 6</th>
      <th>Month 7</th>
      <th>Month 8</th>
      <th>Month 9</th>
      <th>Month 10</th>
      <th>Month 11</th>
      <th>Month 12</th>
    </tr>
  </tfoot> -->
  <tbody class="is-size-7">
    <tr>
      <td class="is-size-6">Revenue</td>
      <td> {{ formatNumber(acquired * dealSize * 1) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 2) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 3) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 4) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 5) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 6) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 7) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 8) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 9) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 10) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 11) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 12) }} </td>
    </tr>
    <tr>
      <td class="is-size-6">Profit</td>
      <td> {{ formatNumber(profit * 1) }} </td>
      <td> {{ formatNumber(profit * 2) }} </td>
      <td> {{ formatNumber(profit * 3) }} </td>
      <td> {{ formatNumber(profit * 4) }} </td>
      <td> {{ formatNumber(profit * 5) }} </td>
      <td> {{ formatNumber(profit * 6) }} </td>
      <td> {{ formatNumber(profit * 7) }} </td>
      <td> {{ formatNumber(profit * 8) }} </td>
      <td> {{ formatNumber(profit * 9) }} </td>
      <td> {{ formatNumber(profit * 10) }} </td>
      <td> {{ formatNumber(profit * 11) }} </td>
      <td> {{ formatNumber(profit * 12) }} </td>
    </tr>
  </tbody>
</table>

</div>

        <h1 class="title is-size-4">Scenario analysis</h1>
        <h2 class="title is-size-5">Scenario 2: Conversion Rate of {{ conversionRate + 0.5 }}%</h2>

<div class="level is-centered">

<table v-show="acquired" class="table is-hoverable is-narrow is-centered">
  <thead class="is-size-5">
    <tr>
      <th><abbr class="is-size-6" title="Scenario">Cumulative</abbr></th>
      <th>{{ this.today | moment("MMM") }}</th>
      <th>{{ this.today | moment("add", "1 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "2 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "3 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "4 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "5 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "6 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "7 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "8 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "9 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "10 month", "MMM") }}</th>
      <th>{{ this.today | moment("add", "11 month", "MMM") }}</th>
    </tr>
  </thead>
  <!-- <tfoot>
    <tr>
      <th><abbr title="Scenario">Scenario</abbr></th>
      <th>Month 1</th>
      <th>Month 2</th>
      <th>Month 3</th>
      <th>Month 4</th>
      <th>Month 5</th>
      <th>Month 6</th>
      <th>Month 7</th>
      <th>Month 8</th>
      <th>Month 9</th>
      <th>Month 10</th>
      <th>Month 11</th>
      <th>Month 12</th>
    </tr>
  </tfoot> -->
  <tbody class="is-size-7">
    <tr>
      <td class="is-size-6">Revenue</td>
      <td> {{ formatNumber(acquiredPlus(0.5) * dealSize * 1) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 2) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 3) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 4) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 5) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 6) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 7) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 8) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 9) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 10) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 11) }} </td>
      <td> {{ formatNumber(acquired * dealSize * 12) }} </td>
    </tr>
    <tr>
      <td class="is-size-6">Profit</td>
      <td> {{ formatNumber(profit * 1) }} </td>
      <td> {{ formatNumber(profit * 2) }} </td>
      <td> {{ formatNumber(profit * 3) }} </td>
      <td> {{ formatNumber(profit * 4) }} </td>
      <td> {{ formatNumber(profit * 5) }} </td>
      <td> {{ formatNumber(profit * 6) }} </td>
      <td> {{ formatNumber(profit * 7) }} </td>
      <td> {{ formatNumber(profit * 8) }} </td>
      <td> {{ formatNumber(profit * 9) }} </td>
      <td> {{ formatNumber(profit * 10) }} </td>
      <td> {{ formatNumber(profit * 11) }} </td>
      <td> {{ formatNumber(profit * 12) }} </td>
    </tr>
  </tbody>
</table>

</div>

      <div class="column">
        <PPCChart :chart-data="datacollection"></PPCChart>
      </div>
  </body>
  </section>

  <!-- <img src="//image.thum.io/get/https://www.google.co.uk/search?q=life+insurance+quotes" /> -->

  <Footer></Footer>

  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header'
import {Money} from 'v-money'
import PPCChart from '@/components/PPCChart'
import Footer from '@/components/Footer'
import ModalAdSpend from '@/components/ModalAdSpend'
import ModalConversionRate from '@/components/ModalConversionRate'
import TableScenario from '@/components/TableScenario'

var moment = require('moment')

export default {
  name: 'SEO',
  components: {
    Header,
    Money,
    PPCChart,
    Footer,
    ModalAdSpend,
    ModalConversionRate,
    TableScenario
  },
  data () {
    return {
      title: 'SEO ROI tool',
      moment: moment,
      today: new Date(),
      month1: this.today | moment("MMM"),
      adSpend: '',
      agencyCost: '',
      agencyFeesIncluded: false,
      testValue: 99,
      costPerClick: '',
      conversionRate: '',
      percentageResponse: 0,
      percentageProposals: '',
      percentageAcquired: '',
      dealSize: '',
      margin: '',
      isActive: false,
      money: {
        // The character used to show the decimal place.
        decimal: '.',
        // The character used to separate numbers in groups of three.
        thousands: ',',
        // The currency name or symbol followed by a space.
        prefix: '£',
        // The suffix (If a suffix is used by the target currency.)
        suffix: '',
        // Level of decimal precision. REQUIRED
        precision: 2,
        // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
        masked: false
      },
      moneyNoDecimal: {
        // The character used to show the decimal place.
        decimal: '.',
        // The character used to separate numbers in groups of three.
        thousands: ',',
        // The currency name or symbol followed by a space.
        prefix: '£',
        // The suffix (If a suffix is used by the target currency.)
        suffix: '',
        // Level of decimal precision. REQUIRED
        precision: 0,
        // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
        masked: false
      },
      percent: {
        // The character used to show the decimal place.
        decimal: '.',
        // The character used to separate numbers in groups of three.
        thousands: '',
        // The currency name or symbol followed by a space.
        prefix: '',
        // The suffix (If a suffix is used by the target currency.)
        suffix: '%',
        // Level of decimal precision. REQUIRED
        precision: 2,
        // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
        masked: false
      },
      percentNoDecimal: {
        // The character used to show the decimal place.
        decimal: '.',
        // The character used to separate numbers in groups of three.
        thousands: '',
        // The currency name or symbol followed by a space.
        prefix: '',
        // The suffix (If a suffix is used by the target currency.)
        suffix: '%',
        // Level of decimal precision. REQUIRED
        precision: 0,
        // If mask is false, outputs the number to the model. Otherwise outputs the masked string.
        masked: false
      },
      // instantiating datacollection with null
      datacollection: null
    }
  },
  watch: {
    profit (newValue, oldValue) {
      console.log('new value: ' + newValue)
      console.log('old value: ' + oldValue)

      this.fillData()
    }
  },
  computed: {
    date: function () {
      return this.today.getFullYear()+'-'+(this.today.getMonth()+1)+'-'+this.today.getDate()
    },
    websiteVisits: function () {
      return this.adSpend / this.costPerClick
    },
    conversions: function () {
      return ((this.adSpend / this.costPerClick) * this.conversionRate) / 100
    },
    costPerConversion: function () {
      return (this.adSpend + this.agencyCost) / this.conversions
    },
    qualityLeads: function () {
      return (this.conversions * this.percentageResponse) / 100
    },
    proposals: function () {
      return (this.qualityLeads * this.percentageProposals) / 100
    },
    acquired: function () {
      return (this.proposals * this.percentageAcquired) / 100
    },
    netRevenue: function () {
      return (this.dealSize * this.margin) / 100
    },
    costPerSale: function () {
      return (this.adSpend + this.agencyCost) / this.acquired
    },
    returnOnPaidInvestment: function () {
      return ((this.netRevenue - this.costPerSale) / this.costPerSale) * 100
    },
    profit: function () {
      return (this.netRevenue - this.costPerSale) * this.acquired
    }
  },
  created () {
  // anytime the vue instance is created, call the fillData() function.
    this.fillData()
  },
  methods: {
    conversionsPlus: function (cr) {
      let newConversions = ((this.adSpend / this.costPerClick) * (this.conversionRate + cr)) / 100
      console.log('newConversions: ' + newConversions)
      return newConversions
    },
    costPerConversionPlus: function () {
      let newcpcp = (this.adSpend + this.agencyCost) / this.conversionsPlus(0.5)

      console.log('costperconversionplus: ' + newcpcp)
    },
    qualityLeadsPlus: function (x) {
      let qlp = (this.conversionsPlus(x) * this.percentageResponse) / 100
      console.log('qlp: ' + qlp)

      return qlp

    },
    proposalsPlus: function (x) {
      console.log("proposalsPlus");
      return (this.qualityLeadsPlus(x) * this.percentageProposals) / 100
    },
    acquiredPlus: function (x) {
      let ap = (this.proposalsPlus(x) * this.percentageAcquired) / 100
      console.log('ap: ' + ap)
      return ap
    },
    closeRate () {
      var crate = (this.percentageResponse / 100) * (this.percentageProposals / 100) * (this.percentageAcquired / 100)
      console.log('closeRate: ' + crate) // E.G. O.2
      return crate
    },
    formatNumber (num) {
      num = Math.round(num)
      return "£" + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    formatNumberOnly (num) {
      num = Math.round(num)
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    toggle () {
      this.isActive = !this.isActive
    },
    showModal () {
      let element = document.getElementById('modal')
      element.classList.add('is-active')
    },
    showModalConversion () {
      let element = document.getElementById('modal-conversion')
      element.classList.add('is-active')
    },
    resetValues () {
      this.adSpend = 0
      this.agencyCost = 0
      this.costPerClick = 0
      this.conversionRate = 0
      this.percentageResponse = 0
      this.percentageProposals = 0
      this.percentageAcquired = 0
      this.dealSize = 0
      this.margin = 0
    },
    qualityLeadsSetter () {
      this.qualityLeads = 43
    },
    dummyValues () {
      this.adSpend = 8000
      this.agencyCost = 0
      this.costPerClick = 4.50
      this.conversionRate = 4.00
      this.percentageResponse = 66
      this.percentageProposals = 67
      this.percentageAcquired = 67
      this.dealSize = 9000
      this.margin = 10
    },
    closeRateTen () {
      this.percentageResponse = 50
      this.percentageProposals = 50
      this.percentageAcquired = 40
    },
    closeRateTwenty () {
      this.percentageResponse = 50
      this.percentageProposals = 50
      this.percentageAcquired = 80
    },
    closeRateThirty () {
      this.percentageResponse = 75
      this.percentageProposals = 66.6
      this.percentageAcquired = 60
    },
    closeRateEcommerce () {
      this.percentageResponse = 100
      this.percentageProposals = 100
      this.percentageAcquired = 100
    },
    // closeRateEnterprise () {
    //   this.percentageResponse = 100
    //   this.percentageProposals = 100
    //   this.percentageAcquired = 100
    // },
    returnOnPaidInvestmentFull (cr) {
      // return Math.round(((this.netRevenue - this.costPerSale ) / this.costPerSale) * 100)
      let cps = ((this.adSpend / this.costPerClick) * (cr / 100)) * (this.percentageResponse / 100) * (this.percentageProposals / 100) * (this.percentageAcquired / 100)

      let leads = (this.adSpend / this.costPerClick) * (cr / 100)
      let ql = leads * (this.percentageResponse / 100)
      let pp = ql * (this.percentageProposals / 100)
      let pa = pp * (this.percentageAcquired / 100)

      let cps2 = ((this.adSpend / pa))

      console.log('adspend: ' + this.adSpend)

      console.log('cps ' + cps)
      console.log('cps2 ' + cps2)
      console.log('pa ' + pa)
      console.log('leads ' + leads)
      console.log('netrevenue ' + this.netRevenue)
      console.log('percentResp: ' + this.percentageResponse)
      console.log('percentProp: ' + this.percentageProposals)
      console.log('percentAcquir: ' + this.percentageAcquired)
      console.log('this profit: ' + this.profit)

      return Math.round(cps2)
    },
    fillData () {
      this.datacollection = {
        // Data for the y-axis of the chart
        labels: [moment().add(0, 'months').format('MMM'), moment().add(1, 'months').format('MMM'), moment().add(2, 'months').format('MMM'), moment().add(3, 'months').format('MMM'), moment().add(4, 'months').format('MMM'), moment().add(5, 'months').format('MMM'), moment().add(6, 'months').format('MMM'), moment().add(7, 'months').format('MMM'), moment().add(8, 'months').format('MMM'), moment().add(9, 'months').format('MMM'), moment().add(10, 'months').format('MMM'), moment().add(11, 'months').format('MMM')],
        datasets: [
          {
            label: 'Revenue at conversion Rate of ' + this.conversionRate + '%',
            // backgroundColor: '#7C0435',
            borderColor: '#7C0435',
            borderWidth: 5,
            backgroundColor: 'rgba(124, 4, 53, .1)',
            // Data for the x-axis of the chart
            data: [Math.round(this.acquired * this.dealSize * 1), Math.round(this.acquired * this.dealSize * 2), Math.round(this.acquired * this.dealSize * 3), Math.round(this.acquired * this.dealSize * 4), Math.round(this.acquired * this.dealSize * 5), Math.round(this.acquired * this.dealSize * 6), Math.round(this.acquired * this.dealSize * 7), Math.round(this.acquired * this.dealSize * 8), Math.round(this.acquired * this.dealSize * 9), Math.round(this.acquired * this.dealSize * 10), Math.round(this.acquired * this.dealSize * 11), Math.round(this.acquired * this.dealSize * 12)]
          },
          {
            label: 'Profit at conversion Rate of ' + this.conversionRate + '%',
            // backgroundColor: '#75BC7F',
            borderColor: '#75BC7F',
            borderWidth: 5,
            backgroundColor: 'rgba(117, 188, 127, 0.1)',
            // Data for the x-axis of the chart
            data: [Math.round(this.profit * 1), Math.round(this.profit * 2), Math.round(this.profit * 3), Math.round(this.profit * 4), Math.round(this.profit * 5), Math.round(this.profit * 6), Math.round(this.profit * 7), Math.round(this.profit * 8), Math.round(this.profit * 9), Math.round(this.profit * 10), Math.round(this.profit * 11), Math.round(this.profit * 12)]
          }
        ]
      }
    }
  }

}
</script>

<style scoped>

.seo {
  background-color: #F5F5F5;
  /* font-family: "Averta","Arial","sans-serif" !important; */
}

body, button, input, select, textarea {
    font-family: "Averta","Arial","sans-serif"
}

.body.columns {
  font-family: "Averta","Arial","sans-serif";
}

#data-input {
  background-color: #FFF;
  /* font-family: "Averta","Arial","sans-serif" !important ; */
}
#scenario-analysis {
  background-color: #FFF;
  /* padding-top: 3rem */
  margin-top: 1.5rem;
  font-family: "Averta","Arial","sans-serif";
}
.tile.is-ancestor:last-child {
    margin-top: 0.75rem;
}
.highlightGreen {
  background-color: #75BC7F;
}
.highlightRed {
  background-color: #7C0435;
  color: #fff;
}
/**
 * Tooltip Styles
 */

/* Base styles for the element that has a tooltip */
[data-tooltip],
.tooltip {
  position: relative;
  cursor: pointer;
}

/* Base styles for the entire tooltip */
[data-tooltip]:before,
[data-tooltip]:after,
.tooltip:before,
.tooltip:after {
  position: absolute;
  visibility: hidden;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
  opacity: 0;
  -webkit-transition:
	  opacity 0.2s ease-in-out,
		visibility 0.2s ease-in-out,
		-webkit-transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
	-moz-transition:
		opacity 0.2s ease-in-out,
		visibility 0.2s ease-in-out,
		-moz-transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
	transition:
		opacity 0.2s ease-in-out,
		visibility 0.2s ease-in-out,
		transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform:    translate3d(0, 0, 0);
  transform:         translate3d(0, 0, 0);
  pointer-events: none;
}

/* Show the entire tooltip on hover and focus */
[data-tooltip]:hover:before,
[data-tooltip]:hover:after,
[data-tooltip]:focus:before,
[data-tooltip]:focus:after,
.tooltip:hover:before,
.tooltip:hover:after,
.tooltip:focus:before,
.tooltip:focus:after {
  visibility: visible;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
  opacity: 1;
}

/* Base styles for the tooltip's directional arrow */
.tooltip:before,
[data-tooltip]:before {
  z-index: 1001;
  border: 6px solid transparent;
  background: transparent;
  content: "";
}

/* Base styles for the tooltip's content area */
.tooltip:after,
[data-tooltip]:after {
  z-index: 1000;
  padding: 8px;
  width: 160px;
  background-color: #000;
  background-color: hsla(0, 0%, 20%, 0.9);
  color: #fff;
  content: attr(data-tooltip);
  font-size: 14px;
  line-height: 1.2;
}

/* Directions */

/* Top (default) */
[data-tooltip]:before,
[data-tooltip]:after,
.tooltip:before,
.tooltip:after,
.tooltip-top:before,
.tooltip-top:after {
  bottom: 100%;
  left: 50%;
}

[data-tooltip]:before,
.tooltip:before,
.tooltip-top:before {
  margin-left: -6px;
  margin-bottom: -12px;
  border-top-color: #000;
  border-top-color: hsla(0, 0%, 20%, 0.9);
}

/* Horizontally align top/bottom tooltips */
[data-tooltip]:after,
.tooltip:after,
.tooltip-top:after {
  margin-left: -80px;
}

[data-tooltip]:hover:before,
[data-tooltip]:hover:after,
[data-tooltip]:focus:before,
[data-tooltip]:focus:after,
.tooltip:hover:before,
.tooltip:hover:after,
.tooltip:focus:before,
.tooltip:focus:after,
.tooltip-top:hover:before,
.tooltip-top:hover:after,
.tooltip-top:focus:before,
.tooltip-top:focus:after {
  -webkit-transform: translateY(-12px);
  -moz-transform:    translateY(-12px);
  transform:         translateY(-12px);
}

/* Left */
.tooltip-left:before,
.tooltip-left:after {
  right: 100%;
  bottom: 50%;
  left: auto;
}

.tooltip-left:before {
  margin-left: 0;
  margin-right: -12px;
  margin-bottom: 0;
  border-top-color: transparent;
  border-left-color: #000;
  border-left-color: hsla(0, 0%, 20%, 0.9);
}

.tooltip-left:hover:before,
.tooltip-left:hover:after,
.tooltip-left:focus:before,
.tooltip-left:focus:after {
  -webkit-transform: translateX(-12px);
  -moz-transform:    translateX(-12px);
  transform:         translateX(-12px);
}

/* Bottom */
.tooltip-bottom:before,
.tooltip-bottom:after {
  top: 100%;
  bottom: auto;
  left: 50%;
}

.tooltip-bottom:before {
  margin-top: -12px;
  margin-bottom: 0;
  border-top-color: transparent;
  border-bottom-color: #000;
  border-bottom-color: hsla(0, 0%, 20%, 0.9);
}

.tooltip-bottom:hover:before,
.tooltip-bottom:hover:after,
.tooltip-bottom:focus:before,
.tooltip-bottom:focus:after {
  -webkit-transform: translateY(12px);
  -moz-transform:    translateY(12px);
  transform:         translateY(12px);
}

/* Right */
.tooltip-right:before,
.tooltip-right:after {
  bottom: 50%;
  left: 100%;
}

.tooltip-right:before {
  margin-bottom: 0;
  margin-left: -12px;
  border-top-color: transparent;
  border-right-color: #000;
  border-right-color: hsla(0, 0%, 20%, 0.9);
}

.tooltip-right:hover:before,
.tooltip-right:hover:after,
.tooltip-right:focus:before,
.tooltip-right:focus:after {
  -webkit-transform: translateX(12px);
  -moz-transform:    translateX(12px);
  transform:         translateX(12px);
}

/* Move directional arrows down a bit for left/right tooltips */
.tooltip-left:before,
.tooltip-right:before {
  top: 3px;
}

/* Vertically center tooltip content for left/right tooltips */
.tooltip-left:after,
.tooltip-right:after {
  margin-left: 0;
  margin-bottom: -16px;
}


</style>
